/* ─── The Description column (MS-701 AC10) ───

   What the call actually did, shaped by invocation type and mode:

     listing            → the endpoint (tools/list)
     ping / initialize  → "Pinging Server" (no payload)
     search  + single   → an array holding the one quoted search string
     search  + batch    → an array of quoted search strings
     invoke  + single   → an array holding the one invoked endpoint
     invoke  + batch    → an array of endpoints

   Search and invoke always read as an array, single or batch. A one-item call and
   an n-item call then have the same shape, so the column can be scanned without
   checking the Invocation Mode column first to know how to read it. Listing
   reports one fixed endpoint and is not a list, so it stays bare.

   The server sorts on this exact string (`DESCRIPTION_LABEL_SQL` in
   mcp_analytics_repository.py), so any change here needs the same change there or
   the Description sort orders by something the reader is not seeing. */

import { inlineArray, sortedForMode } from './arrays'
import { invocationTypeForStoredValue } from './invocationTypes'

const PING_LABEL = 'Pinging Server'

export interface DescribableRow {
  invocationType: string
  invocationMode: string
  descriptionItems: readonly string[]
}

export function descriptionText(row: DescribableRow): string {
  // A ping carries no payload; anything on the row is ignored rather than shown.
  if (invocationTypeForStoredValue(row.invocationType)?.key === 'ping') return PING_LABEL

  const items = sortedForMode(row.descriptionItems, row.invocationMode)
  if (items.length === 0) return ''
  if (row.invocationType === 'listing') return items[0]
  return inlineArray(items, { quoted: row.invocationType === 'search' })
}
